(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function findFilterSummary() {
    return [...document.querySelectorAll('summary')]
      .find(s => {
        const text = (s.textContent || '').trim().toLowerCase();
        return text.includes('filtrele ve sırala') || text.includes('filter and sort');
      });
  }

  function moveAndRenameProductType(form) {
    // Olası kapsayıcılar
    const container =
      form.querySelector('.mobile-facets__main') ||
      form.querySelector('.mobile-facets__details') ||
      form;

    // Ürün türü bloğunu bul
    const candidates = [...container.querySelectorAll(':scope > details, :scope > div, :scope > fieldset')];
    let target = candidates.find(el => (el.textContent || '').trim().toLowerCase().startsWith('ürün türü'));

    if (!target) {
      target = [...form.querySelectorAll('details, .mobile-facets__details, .facet, fieldset, div')]
        .find(el => {
          const t = (el.textContent || '').trim().toLowerCase();
          return t.startsWith('ürün türü') || t.includes('\nürün türü') || t.includes('ürün türü');
        });
    }

    if (!target || !target.parentElement) return;

    // En üste taşı
    target.parentElement.insertBefore(target, target.parentElement.firstChild);

    // Başlığı "Tür" yap
    const labelEl = [...target.querySelectorAll('summary, h3, h2, span, p, button')]
      .find(el => (el.textContent || '').trim().toLowerCase() === 'ürün türü');

    if (labelEl) {
      labelEl.textContent = 'Tür';
      return;
    }

    // Fallback: ilk text node replace
    const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.trim().toLowerCase() === 'ürün türü') {
        node.nodeValue = 'Tür';
        break;
      }
    }
  }

  function ensureFormPlacedBelowButton(summary, form) {
    const host = summary.closest('.page-width, .collection, .section') || summary.parentElement;
    (host || summary.parentElement).insertAdjacentElement('afterend', form);
  }

  function handler(e) {
    if (!isMobile()) return;

    const summary = e.target.closest('summary');
    const targetSummary = findFilterSummary();
    if (!targetSummary || summary !== targetSummary) return;

    const form = document.getElementById('CollectionFiltersFormMobile');
    if (!form) return;

    // Tema drawer davranışını engelle
    e.preventDefault();
    e.stopPropagation();

    ensureFormPlacedBelowButton(targetSummary, form);

    const open = !document.body.classList.contains('imc-inline-filters-open');
    document.body.classList.toggle('imc-inline-filters-open', open);

    try { targetSummary.setAttribute('aria-expanded', open ? 'true' : 'false'); } catch {}

    // Tema scroll lock eklediyse kaldır
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');

    if (open) moveAndRenameProductType(form);
  }

  document.addEventListener('click', handler, true);

  // Sayfa yüklenince hazır olsun (özellikle Shopify section reload’larında)
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('CollectionFiltersFormMobile');
    if (form) moveAndRenameProductType(form);
  });
})();
